import {useRef,useMemo} from "react";
import {useLocation} from "react-router-dom";
import COMPONENT_MAP from '../Repository/Components.js';

const AccountSalesOrders=({parentId,application,userData,parent})=>{
    const list_name='account_sales_orders';
    const executeQuery=useRef(true);
    const location=useLocation();
    const navigateOnNew={route:'/sales_order/new/',args:{state:{from:location.pathname,context:{
        parent_name:'Account',
        parent_field_name:'account_id',
        parent_field_value:parentId
    }}}};

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                parent={parent}
                application={application}
                userData={userData}
                entityType={'SalesOrder'}
                entityParams={['account_id='+parentId,'_context='+['parent_name=Account'],'_lang='+application.globalData.lang]}
                list_name={list_name}
                getRowClassName={(params)=>
                    (params.row.status&&application.globalData.list_of_values_reverse.Sales_Order_Status[params.row.status]==='LOGISTICS_INTEGRATION_ERROR')?'highlight-row':''
                }
                dataGridSx={{
                    "& .highlight-row":{
                        backgroundColor:"#ffe6f0 !important",
                        color: "black",
                    }
                }}
                // height={'50vh'}
                file={'AccountSalesOrders.js'}
                navigateOnNew={navigateOnNew}
                initialState={{}}
                checkboxSelection={false}
                disableRowSelectionOnClick={false}
                disableSelectionOnClick={false}
                popupComponent={null}
                parentContext={{
                    parent_field_name:'account_id',
                    parent_field_value:null,
                    parent_name:'Account'
                }}
                executeQuery={executeQuery}
            />
        ):null; 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name]]);

    return(renderListTab);
}
export default AccountSalesOrders;